import type { TFunction } from 'i18next';

import { DateTime } from 'luxon';

import { ChartInterval } from '../types.ts';
import { chartIntervalValueToKey } from './chartIntervalValueToKey.ts';

type ChartNameParams = {
  baseName: string | undefined;
  isLive: boolean;
  interval: ChartInterval;
  from?: DateTime;
  to?: DateTime;
  t: TFunction<['chartConfig'], string>;
};

/**
 * Generates a chart name with period explanation.
 * For live charts: "Base Name • Last [interval]"
 * For historical charts: "Base Name • [from date] to [to date]"
 */
export const getChartNameWithPeriod = ({
  baseName,
  isLive,
  interval,
  from,
  to,
  t,
}: ChartNameParams): string | undefined => {
  if (isLive) {
    const intervalKey = chartIntervalValueToKey[interval];
    if (!intervalKey) return baseName;

    const intervalLabel = t(`chartConfig:chartInterval.${intervalKey}`, 'missing interval label');
    const lastLabel = t('chartConfig:last');
    const periodText = `${lastLabel} ${intervalLabel}`;
    return baseName ? `${baseName} • ${periodText}` : periodText;
  }

  if (from && to) {
    return t('chartConfig:dateRangeTooltip', {
      item: baseName || '',
      start: from.toJSDate().toLocaleDateString(),
      end: to.toJSDate().toLocaleDateString(),
    });
  }

  return baseName;
};
